import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Home from "@/pages/Home";
import Confirmation from "@/pages/Confirmation";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import { privacy, terms, cookies } from "@/legal";
import { LEGAL_ROUTES } from "@/content";
import { CookieBanner } from "@/components/site/CookieBanner";

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/confirmare/:ref" element={<Confirmation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path={LEGAL_ROUTES.privacy} element={<LegalPage doc={privacy} />} />
          <Route path={LEGAL_ROUTES.terms} element={<LegalPage doc={terms} />} />
          <Route path={LEGAL_ROUTES.cookies} element={<LegalPage doc={cookies} />} />
        </Routes>
        <CookieBanner />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
